import React, {useState, useEffect, forwardRef, useRef, useImperativeHandle} from "react";
import {DataTable} from "primereact/datatable";
import {InputTextCustomer} from "..";
import "./TableCustomer.css";
import {Button} from "primereact/button";
import {Badge} from 'primereact/badge';
import {InputText} from "primereact/inputtext";

export const TableCustomer = forwardRef((props, ref) => {
        const [data, setData] = useState(props.data);
        const [bigData, setBigData] = useState({});
        const [dataUpdated, setDataUpdated] = useState({});
        const [first, setFirst] = useState(0);
        const [globalFilter, setGlobalFilter] = useState(null);
        const [loading, setLoading] = useState(false)
        const [refresh, setRefresh] = useState(false)
        const [rows, setRows] = useState(10);
        const [currentPage, setCurrentPage] = useState(1);
        const dt = useRef(null);


        useEffect(() => {
            setData(bigData);
        }, [bigData])

        useEffect(function effectFunction() {
            if (dataUpdated) {
                var index = dataUpdated?.id
                setData([...data.slice(0, index), dataUpdated, ...data.slice(index + 1)]);
            }
        }, [dataUpdated]);

        useEffect(() => {
            setData(props.data)
        }, [loading, refresh])

        const _onGlobalFilter = (e) => {
            setGlobalFilter(e.target.value)
        }

        useImperativeHandle(ref,
            () => ({
                onFilter(value, name, type) {
                    setLoading(true)
                    dt.current.filter(value, name, type);
                },
                onFilterListContains(value, name) {
                    setLoading(true)
                    filterListContains(value, name)
                },
                onFilterElementContains(value, name) {
                    setLoading(true)
                    filterElementContains(value, name)
                },
                onFilterDate(date_min, date_max, name) {
                    setLoading(true)
                    filterDate(date_min, date_max, name);
                },
                onRefresh() {
                    setRefresh(false)
                },
                loadingData() {
                    loadingData()
                },
                updateData(dataOld) {
                    setDataUpdated(dataOld)
                },


            })
        );
        const loadingData = () => {
            setRefresh(true)
            props.refresh();

        }

        const filterListContains = (value, name) => {
            if (!value) {
                setBigData(props.data)
            } else {
                setBigData(props.data.filter(function (e) {
                    let list = e[name]
                    return (list.includes(value));
                }))
            }
        }
        const filterElementContains = (value, name) => {
            if (!value) {
                setBigData(props.data)
            } else {
                setBigData(props.data.filter(function (e) {
                    let element = e[name]
                    return (value.includes(element));
                }))
            }
        }

        const filterDate = (date_min, date_max, name) => {
            if (date_min && date_max) {
                const d1 = new Date(date_min);
                const d2 = new Date(date_max);
                setBigData(props.data.filter(function (e) {
                    const d = new Date(e[name]);
                    return (d.getTime() >= d1.getTime() && d.getTime() <= d2.getTime());
                }));
            }
            if (!date_min && date_max) {
                const d2 = new Date(date_max);
                setBigData(props.data.filter(function (e) {
                    const d = new Date(e[name]);
                    return (d.getTime() <= d2.getTime());
                }));
            }

            if (date_min && !date_max) {
                const d1 = new Date(date_min);
                setBigData(props.data.filter(function (e) {
                    const d = new Date(e[name]);
                    return (d.getTime() >= d1.getTime());
                }));
            }
            if (!date_min && !date_max) {
                setBigData(props.data)
            }
        }

        let header = (
            <div class="nav d-flex justify-content-between px-4 custom-primary-nav-header py-3 header-scr">
                <div>{props.title}</div>
                <div style={{
                    'width': '50%',
                    'display': 'block',
                    'justifyContent': 'left', 'alignItems': 'center'
                }}>
                    {props.header}
                </div>
                <div style={{
                    'display': 'flex',
                    'justifyContent': 'center', 'alignItems': 'center'
                }}>

                    {props.search ? <span className="p-input-icon-left">
                        <i className="pi pi-search"/>
                        <InputText style={{'height': '1.6rem'}} size="25" onChange={_onGlobalFilter}
                                   placeholder="Search"/>
                    </span> : ''}
                    {props.refresh ? <i className={`pi p-button-loading ${refresh ? 'pi-spin pi-spinner' : 'pi-refresh'}`}
                                        onClick={loadingData}></i> : ''}
                    {props.add ? <i className=" pi p-button-loading  bi bi-plus-circle-fill"
                                    onClick={props.add}></i> : ''}

                    <small className="badge badge-secondary"
                           style={{'height': '1.1rem', 'margin-left': '0.4rem '}}>{props.data?.length}</small>
                </div>

            </div>
        );

        let headerr = (
            <div className="p-grid p-justify-between header-scr">
                <div className="p-col-5">
                    <i className={props.icon} style={{'fontSize': '1em'}}>
                        {"  " + props.title + "   "}
                        <Badge size="small" severity="info" value={props.data?.length}></Badge>
                    </i>
                </div>
                <div className="p-col-5 justify-content-center">
                    <InputTextCustomer
                        type="search"
                        onChange={_onGlobalFilter}
                        label="Global Search"
                        icon='pi pi-search'
                        size="50"/>
                </div>
                <div className="p-col justify-content-center">
                    {props.add ?
                        <Button className='p-button-tcs p-button-success p-button-tcs-grlback ' onClick={props.add}
                                icon="p-button-tcs-grlback pi bi bi-plus-circle-fill"/>
                        : ''}
                    {props.refresh ?
                        refresh ? <i className="pi  p-button-loading pi-spin pi-spinner"></i>
                            : <Button className='p-button-tcs p-button-tcs-grlback' onClick={loadingData}
                                      icon="pi p-button-tcs-grlback pi-refresh"/>
                        : ''}
                </div>
            </div>
        );

        const onCustomPage = (event) => {
            setFirst(event.first);
            setRows(event.rows);
            setCurrentPage(event.page + 1);
        }

        return (
            <DataTable
                value={data}
                header={header}
                ref={dt}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                paginator
                paginatorPosition="bottom"
                first={first}
                rows={rows}
                onPage={onCustomPage}
                emptyMessage="No data found."
                globalFilter={globalFilter}
                className={`p-datatable-striped ${props.className}`}
            >
                {props.columns}
            </DataTable>
        );

    }
);
